import { render, staticRenderFns } from "./SitePowerTable.vue?vue&type=template&id=922c8a30&scoped=true&"
import script from "./SitePowerTable.vue?vue&type=script&lang=js&"
export * from "./SitePowerTable.vue?vue&type=script&lang=js&"
import style0 from "./SitePowerTable.vue?vue&type=style&index=0&id=922c8a30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922c8a30",
  null
  
)

export default component.exports